import { SendStateNames } from "ui/transactions/transactions.types";
import getQueryParams from "../utils/getQueryParams";

export default function useDestinationAddressPath(redirectPath: string): string {
    const params = getQueryParams();
    if (!params.destinationAddress) {
        return redirectPath;
    }
    return `${redirectPath}?${SendStateNames.DESTINATION_ADDRESS}=${params.destinationAddress}`;
}
